class Extension {
  name = "Extension"
  static autoregister = true;
  
  constructor(name) {
    this.name = name || this.name;
  }

  init() {}

  get logPrefix() {
    return `\x1b[30;46;1m[Extension/${this.name.match(/[A-Z]/g).join("-")}]`;
  }
}

export default Extension;